import React, { useEffect, useState, useRef, useCallback } from 'react'
import { Button } from '@arnsbogroup/react-voicearchive'

const Invite = ({ onSubmit }) => {
  const messageRef = useRef(null)
  const [message, setMessage] = useState('')
  const [suppliers, setSuppliers] = useState([])
  const [selected, setSelected] = useState(null)

  useEffect(() => {
    fetch(`/supplier/onboardingCandidates.json`)
      .then((response) => response.json())
      .then(({ data }) => setSuppliers(data))
  }, [])

  const onSend = useCallback(() => {
    fetch(`/supplier/onboardCandidates.json`, {
      method: 'POST',
      body: JSON.stringify({
        message,
        ids: selected,
      })
    })
      .then((response) => response.json())
      .then(onSubmit)
      .catch((error) => window.alert(error))
  }, [message, selected])


  return (
    <div className="w-full h-full flex flex-col p-4">
      <select
        multiple
        value={selected}
        onChange={({ target: { selectedOptions } }) => setSelected(Array.from(selectedOptions, ({ value }) => value))}
        className="grow overflow-y-scroll"
      >
        { suppliers.map(({ uid, userid, applicant }) => {
          return (
            <option key={uid} className="w-auto py-2" value={uid}>
              { userid } { applicant && `(Applicant)` }
            </option>
          )
        }) }
      </select>

      <div className="py-4">
        <textarea
          ref={messageRef}
          className="px-4 py-2 rounded-sm text-sm border border-gray-400 w-full"
          value={message}
          onFocus={() => messageRef.current.classList.add('h-40')}
          onBlur={() => messageRef.current && messageRef.current.classList.remove('h-40')}
          onChange={({ target: { value } }) => setMessage(value)}
          placeholder="Add message to e-mail.."
        />
        <div className='text-right'>
          <Button
            size='sm'
            onClick={onSend}
          >
            Invite
          </Button>
        </div>
      </div>
    </div>
  )
}

export default Invite
